import type { Character } from '~/api/interface/character';
import { ACTOR_NAV, CONFIG_NAV, CONTENT_TABS } from '~/constants';
import { createWorkByCharacter } from '~/features/createWork';

export const useCharacterCreateOps = () => {
  // const userInfo = useUserInfo();
  // const { $t } = useNuxtApp();

  const createOps = (type: 'image' | 'person', character: Character) => {
    // 前端判断当前资产用户是否可用
    // if (
    //   userInfo.value?.rights_type &&
    //   character?.config_type &&
    //   character?.config_type > userInfo.value?.rights_type
    // ) {
    //   const text = USER_LEVEL()[character?.config_type]?.name;

    //   message.warning(
    //     $t('dang-qian-jiao-se-shi-text-zi-chan-ru-xu-shi-yong-qing-sheng-ji', [text])
    //   );

    //   return;
    // }

    if (type === 'image') {
      createWorkByCharacter(character!.id, {
        nav: CONFIG_NAV.ACTOR,
        tab: {
          [ACTOR_NAV.COLLECTION]: true,
        },
      });
    } else {
      createWorkByCharacter(character!.id, {
        nav: CONFIG_NAV.CONTENT,
        tab: CONTENT_TABS.CHARACTER,
      });
    }
  };

  return { createOps };
};
